import { useSetRecoilState } from 'recoil';
import { alertDialogAtom } from '../recoil/dialog';
export function useAlertDialog() {
    return useSetRecoilState(alertDialogAtom);
}
